import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tw-flex tw-items-center tw-gap-1.5" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.allowTimeToggling)
      ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          disabled: _ctx.isDisabled,
          class: _normalizeClass(["tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border tw-transition-colors disabled:tw-opacity-40 disabled:tw-cursor-not-allowed", _ctx.isTimeEnabled
        ? 'tw-border-indigo-200 tw-bg-indigo-50 tw-text-indigo-600 hover:tw-bg-indigo-100'
        : 'tw-border-slate-200 tw-bg-white tw-text-slate-400 hover:tw-bg-slate-50']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleTime')))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["tw-relative tw-inline-flex tw-items-center tw-justify-center", { 'time-disabled-slash': !_ctx.isTimeEnabled }])
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "clock",
              class: "tw-h-3.5 tw-w-3.5"
            })
          ], 2)
        ], 10, _hoisted_2)), [
          [_directive_tippy, { content: _ctx.isTimeEnabled ? 'Time enabled — click to use date only' : 'Date only — click to add a time', placement: 'bottom' }]
        ])
      : _createCommentVNode("", true),
    (_ctx.showDaysShortcuts)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            disabled: _ctx.isDisabled,
            class: "tw-inline-flex tw-h-7 tw-items-center tw-gap-1 tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-text-xs tw-text-slate-600 tw-transition-colors hover:tw-bg-slate-50 disabled:tw-opacity-40 disabled:tw-cursor-not-allowed",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('setToday')))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "calendar-day",
              class: "tw-h-3 tw-w-3"
            }),
            _cache[4] || (_cache[4] = _createTextVNode(" today ", -1))
          ], 8, _hoisted_3)), [
            [_directive_tippy, { content: 'Today', placement: 'bottom' }]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            disabled: _ctx.isDisabled,
            class: "tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-text-slate-600 tw-transition-colors hover:tw-bg-slate-50 disabled:tw-opacity-40 disabled:tw-cursor-not-allowed",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('shiftDays', -1)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "minus",
              class: "tw-h-3 tw-w-3"
            })
          ], 8, _hoisted_4)), [
            [_directive_tippy, { content: 'One day earlier', placement: 'bottom' }]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            disabled: _ctx.isDisabled,
            class: "tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-text-slate-600 tw-transition-colors hover:tw-bg-slate-50 disabled:tw-opacity-40 disabled:tw-cursor-not-allowed",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('shiftDays', 1)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "plus",
              class: "tw-h-3 tw-w-3"
            })
          ], 8, _hoisted_5)), [
            [_directive_tippy, { content: 'One day later', placement: 'bottom' }]
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}